import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translations, { LANGUAGES } from './translations';

const resources = Object.fromEntries(
  LANGUAGES.map(l => [l.code, { translation: translations[l.code] || translations.en }])
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: LANGUAGES.map(l => l.code),
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'navkar_language',
      caches: ['localStorage'],
    },
  });

// Set document direction & lang whenever language changes
const applyLang = (lng) => {
  const meta = LANGUAGES.find(l => l.code === lng) || LANGUAGES[0];
  document.documentElement.lang = meta.code;
  document.documentElement.dir = meta.dir;
};

i18n.on('languageChanged', applyLang);
applyLang(i18n.language);

export default i18n;
